const layout = {
    input: {
        maxWidth: "400px",
        defaultWidth: "100%",
    },
};

export default layout;
